import React from 'react'
import {Table} from "react-bootstrap";
import storage from "../../../Storage";
import {encode, wait, fixDate} from "../../../Helper";
import C from "../../../Constant";
import socket from "../../../Socket";

class Earnings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            list: []
        };
    }

    componentDidMount() {
        wait(1700).then(() => {
            this.setState({loading: false});
        })
        socket.emit(C.REF_EARNINGS, encode({token: storage.getKey('token')}));
        socket.on(C.REF_EARNINGS, data => this.makeList(data));
    }

    makeList = (data) => {
        this.setState({loading: false, list: data});
    }

    render() {

        const list = this.state.list.map((row, index) =>
            <EarnList key={index} row={row}/>
        );

        return (
            <div className="table-responsive">
                {
                    this.state.loading ?
                        <div className="text-center">
                            <div class="spinner-border text-info my-3" role="status"/>
                        </div>
                        :
                        <>
                            {list.length === 0 ?
                                <>
                                    [No Earnings Yet]
                                </>
                                :
                                <Table className={"mb-2"}>
                                    <thead>
                                    <tr>
                                        <th>
                                            Date/Time
                                        </th>
                                        <th>
                                            From
                                        </th>
                                        <th>
                                            Amount
                                        </th>
                                        <th>
                                            Earnings
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {list}
                                    </tbody>
                                </Table>
                            }
                        </>
                }
            </div>
        );
    }
}

class EarnList extends React.Component {
    render() {

        const {key, row} = this.props
        return (
            <tr>
                <td>
                    {fixDate(row.created)}
                </td>
                <td>
                    {row.name}
                </td>
                <td>
                    {row.amount}
                </td>
                <td>
                    {row.earnings}
                </td>
            </tr>
        );
    }
}

export default Earnings;